"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useIconProps = require("../useIconProps");

var FeedbackSuccess = function FeedbackSuccess(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 16 16"
  }, (0, _useIconProps.useIconProps)(props)), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.972 11.921l-.004-.003-2.822-2.822a.5.5 0 010-.707l.708-.707a.5.5 0 01.707 0L6.328 9.45l5.304-5.304a.5.5 0 01.707 0l.707.708a.5.5 0 010 .707l-6.364 6.364a.5.5 0 01-.707 0l-.003-.004z"
  }));
};

FeedbackSuccess.displayName = 'FeedbackSuccess';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  FeedbackSuccess.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

var _default = FeedbackSuccess;
exports.default = _default;